export const INVITATIONS = "invitations";